export const CROSS_SELL_ANALYTICS_DATA_NAME = 'crosssell-widget'
export const CROSS_SELL_ANALYTICS_ATTR_IMAGE = 'item-image'
export const CROSS_SELL_ANALYTICS_ATTR_TITLE = 'item-title'
